"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linkedin = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Linkedin(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 0.89543 1.39543 0 2.5 0C3.03043 0 3.53914 0.210714 3.91421 0.585786C4.28929 0.960859 4.5 1.46957 4.5 2C4.5 3.10457 3.60457 4 2.5 4C1.39543 4 0.5 3.10457 0.5 2ZM18 10.41C18.0345 8.2449 16.5574 6.34762 14.45 5.85C13.0377 5.5459 11.5657 5.94467 10.5 6.92V6.5C10.5 6.22386 10.2761 6 10 6H7.5C7.22386 6 7 6.22386 7 6.5V16.5C7 16.7761 7.22386 17 7.5 17H10C10.2761 17 10.5 16.7761 10.5 16.5V10.86C10.4753 9.85571 11.1753 8.97867 12.16 8.78C12.7464 8.67878 13.3473 8.8439 13.7997 9.2305C14.252 9.61711 14.5087 10.185 14.5 10.78V16.5C14.5 16.7761 14.7239 17 15 17H17.5C17.7761 17 18 16.7761 18 16.5V10.41ZM4.5 6.5V16.5C4.5 16.7761 4.27614 17 4 17H1.5C1.22386 17 1 16.7761 1 16.5V6.5C1 6.22386 1.22386 6 1.5 6H4C4.27614 6 4.5 6.22386 4.5 6.5Z",
    fill: "currentColor"
  }));
}

exports.Linkedin = Linkedin;